// Polyfill React.useId for React 17 compatibility
// We're using React 17.0.2, but useId was introduced in React 18
// Some dependencies like formatic 2.2.0 require useId, so we polyfill it
//
// TODO: Remove this file when migrating to React 18, as useId is natively supported
import React from 'react';

// Extend React namespace to include useId for TypeScript
declare module 'react' {
  // eslint-disable-next-line no-unused-vars
  function useId(): string;
}

if (!React.useId) {
  let idCounter = 0;
  React.useId = function useId() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const ref = React.useRef<string>();
    if (ref.current === undefined) {
      // eslint-disable-next-line no-plusplus
      ref.current = `:r${idCounter++}:`;
    }
    return ref.current;
  };
}
